export const ACCOUNT_ACTIVITY_PATH = '/home/accountActivity';
